var staticDayTime = require('./staticDayTime')

var staticWeekTime = staticDayTime * 7

module.exports = staticWeekTime



//////////////////
// WEBPACK FOOTER
// ./~/.store/xe-utils@3.7.9/~/xe-utils/staticWeekTime.js
// module id = 538
// module chunks = 75